/* Shared room-scene prompts for Promote and the product-page staff studio. */
(function (root) {
  "use strict";

  function foldText(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
  }

  function weakGenre(genre) {
    return !genre || /^(print|prints|art|artwork|uncategorized|default|original|originals)$/i.test(String(genre).trim());
  }

  function prettyList(items) {
    if (!items.length) return "";
    if (items.length === 1) return items[0];
    if (items.length === 2) return items[0] + " and " + items[1];
    return items.slice(0, items.length - 1).join(", ") + " and " + items[items.length - 1];
  }

  function colourLabels(product) {
    var seen = {};
    var out = [];
    ((product && product.colours) || []).forEach(function (raw) {
      var label = String(raw || "").replace(/\s+/g, " ").trim();
      var key = foldText(label);
      if (!key || seen[key] || /^(none|n a|other|multi|multicolou?r|mixed)$/.test(key)) return;
      seen[key] = true;
      out.push(label);
    });
    return out.slice(0, 3);
  }

  function collectionVoice(product) {
    var list = (product && product.collections) || [];
    var i;
    for (i = 0; i < list.length; i += 1) {
      var title = String(list[i].title || list[i] || "").trim();
      if (title && !weakGenre(title) && !/rosenstiel/i.test(title)) return title;
    }
    if (!weakGenre(product && product.genre)) return product.genre;
    return "";
  }

  function pickOne(list) {
    if (!list || !list.length) return null;
    return list[Math.floor(Math.random() * list.length)];
  }

  function fallbackFrameSize(product) {
    var ori = foldText(product && product.orientation);
    var rosen = !!(product && product.rosenstiels);
    if (/square/.test(ori)) return rosen ? { label: "90×90cm", w: 90, h: 90 } : { label: "75×75cm", w: 75, h: 75 };
    if (/land|pano/.test(ori)) return rosen ? { label: "120×95cm", w: 120, h: 95 } : { label: "100×70cm", w: 100, h: 70 };
    return rosen ? { label: "95×120cm", w: 95, h: 120 } : { label: "70×100cm", w: 70, h: 100 };
  }

  function frameSizeFor(product) {
    var given = product && product.frameSize;
    var w = given && Number(given.w);
    var h = given && Number(given.h);
    if (w > 0 && h > 0) {
      return {
        label: String(given.label || "").trim() || (w + "×" + h + "cm"),
        w: w,
        h: h
      };
    }
    return fallbackFrameSize(product);
  }

  function emptyFrameFacts() {
    return { style: "", colour: "", mount: "", mountColour: "" };
  }

  function phraseColour(value) {
    return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function titleColour(raw) {
    var clean = String(raw || "").replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
    if (!clean || /^(frame|colour|color|mount|style)$/i.test(clean)) return "";
    return clean.replace(/\b[a-z]/g, function (ch) { return ch.toUpperCase(); });
  }

  function styleFacts(raw) {
    var v = String(raw || "").toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
    if (!v) return null;
    if (/deep|wide box|widebox/.test(v)) return { name: "Deep Classic", adj: "deep" };
    if (v.indexOf("swoop") > -1) return { name: "Swoop", adj: "wide" };
    if (v.indexOf("venice") > -1) return { name: "Venice", adj: "stepped" };
    if (/classic|standard/.test(v)) return { name: "Classic", adj: "slim" };
    return null;
  }

  function mountKind(raw) {
    var v = String(raw || "").toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
    if (!v) return "";
    if (/no mount|none|unmounted|^no$/.test(v)) return "none";
    if (v === "mounted" || v === "mount" || v === "yes" || v === "with mount") return "mounted";
    return "";
  }

  function pickOption(options, keys) {
    var obj = options && typeof options === "object" ? options : {};
    var i;
    for (i = 0; i < keys.length; i += 1) {
      var value = obj[keys[i]];
      if (typeof value === "string" && value.replace(/\s+/g, " ").trim()) return value.replace(/\s+/g, " ").trim();
    }
    return "";
  }

  function factsFromOptions(options) {
    var styled = styleFacts(pickOption(options, ["frameStyle", "style", "frame"]));
    var mount = mountKind(pickOption(options, ["mount"]));
    return {
      style: styled ? styled.name : "",
      colour: titleColour(pickOption(options, ["colour", "color"])),
      mount: mount,
      mountColour: mount === "mounted" ? titleColour(pickOption(options, ["mountColour", "mount_colour", "mountColor"])) : ""
    };
  }

  function factsFromFilename(url) {
    var file = String(url || "").split("?")[0].split("/").pop().toLowerCase();
    var stem = file.replace(/\.(png|jpe?g|webp)$/, "");
    var mount = "";
    if (/-no-mount$/.test(stem)) {
      mount = "none";
      stem = stem.slice(0, -"-no-mount".length);
    } else if (/-mounted$/.test(stem)) {
      mount = "mounted";
      stem = stem.slice(0, -"-mounted".length);
    } else {
      return emptyFrameFacts();
    }
    var styles = ["deep-classic", "swoop", "venice", "classic"];
    var best = null;
    var i;
    for (i = 0; i < styles.length; i += 1) {
      var token = "-" + styles[i] + "-";
      var idx = stem.lastIndexOf(token);
      if (idx < 0) continue;
      if (styles[i] === "classic" && stem.slice(idx - 4, idx) === "deep") continue;
      var colour = stem.slice(idx + token.length);
      if (!colour || !/^[a-z0-9-]+$/.test(colour)) continue;
      if (!best || idx > best.idx) best = { idx: idx, style: styles[i], colour: colour };
    }
    if (!best) return emptyFrameFacts();
    var styled = styleFacts(best.style);
    return {
      style: styled ? styled.name : "",
      colour: titleColour(best.colour),
      mount: mount,
      mountColour: ""
    };
  }

  function resolveFrameFacts(options, imageUrl) {
    var named = factsFromOptions(options);
    var file = factsFromFilename(imageUrl);
    var mount = named.mount || file.mount;
    return {
      style: named.style || file.style,
      colour: named.colour || file.colour,
      mount: mount,
      mountColour: mount === "mounted" ? (named.mountColour || file.mountColour) : ""
    };
  }

  function mouldingPhrase(facts) {
    var styled = styleFacts(facts.style);
    var colour = phraseColour(facts.colour);
    if (styled && colour) return "a " + styled.adj + " " + colour + " " + styled.name + " moulding";
    if (styled) return "a " + styled.adj + " " + styled.name + " moulding";
    if (colour) return "a " + colour + " moulding";
    return "";
  }

  function mountBoardPhrase(facts) {
    if (!facts || facts.mount !== "mounted") return "";
    var colour = phraseColour(facts.mountColour);
    if (colour) return "a " + colour + " mount board between the print and the moulding";
    return "a mount board between the print and the moulding";
  }

  function describeFacts(facts) {
    var moulding = mouldingPhrase(facts || emptyFrameFacts());
    var board = mountBoardPhrase(facts);
    if (moulding && facts && facts.mount === "none") {
      return "The frame is " + moulding + " with no mount board — the print meets the moulding directly.";
    }
    if (moulding && board) return "The frame is " + moulding + " with " + board + ".";
    if (moulding) return "The frame is " + moulding + ".";
    if (facts && facts.mount === "none") return "The frame has no mount board — the print meets the moulding directly.";
    if (board) return "The frame has " + board + ".";
    return "";
  }

  function describeFrame(product) {
    var source = product || {};
    return describeFacts(resolveFrameFacts(source.frameOptions || null, source.image || ""));
  }

  function framedPrintLine(cm, facts) {
    var sentence = describeFacts(facts);
    var lead = sentence ? sentence + " " : "";
    return "The attached image is the exact framed print, " + cm + " overall. " + lead +
      "Do not redraw the painting, and do not split it into panels. It is already hung and correctly sized. Do not move, resize, crop, or recolour the print. Paint the room only in the empty background around it.";
  }

  function frameScaleCopy(product) {
    var size = frameSizeFor(product);
    var long = Math.max(size.w, size.h);
    var cm = size.w + "×" + size.h + "cm";
    var label = String(size.label || "").toLowerCase();
    var multi = /triptych/.test(label) ? "triptych" : /diptych/.test(label) ? "diptych" : "";
    var facts = resolveFrameFacts((product && product.frameOptions) || null, (product && product.image) || "");
    var sentence = product && product.lockImage ? "" : describeFacts(facts);
    var furniture;
    if (long >= 90) {
      furniture = "This is a statement size, about a metre on the long side. A typical 3-seat sofa is 180–210cm; the frame should span a generous portion of that wall — roughly half a sofa — not float as a small picture on a vast empty wall.";
    } else if (long >= 70) {
      furniture = "This is a generous domestic size. Include enough furniture to prove the scale, but keep the camera close enough that the print is clearly the subject.";
    } else {
      furniture = "Keep the camera close enough to read the artwork. A chair, lamp, or console in shot is enough to prove scale.";
    }
    var line = multi
      ? "The attached image is the exact " + multi + ", " + cm + " overall. " + (sentence ? sentence + " " : "") +
        "Hang that image with the same panels, gaps, and artwork. Do not redraw the painting. It is already hung and correctly sized. Do not move, resize, crop, or recolour the print. Paint the room only in the empty background around it. " + furniture + " No ultrawide room shot. No extra frames."
      : framedPrintLine(cm, product && product.lockImage ? emptyFrameFacts() : facts) + " " + furniture + " No ultrawide room shot. No extra frames.";
    return {
      size: size,
      cm: cm,
      line: line
    };
  }

  function oriKind(product) {
    var ori = foldText(product && product.orientation);
    if (/pano/.test(ori)) return "pano";
    if (/landscape/.test(ori)) return "landscape";
    if (/square/.test(ori)) return "square";
    return "portrait";
  }

  function sceneSignals(product) {
    var text = foldText([
      product.title,
      product.genre,
      product.blurb,
      collectionVoice(product),
      (product.moods || []).join(" "),
      (product.colours || []).join(" ")
    ].join(" "));
    var colours = foldText(colourLabels(product).join(" "));
    var frame = frameSizeFor(product);
    return {
      text: text,
      ori: oriKind(product),
      coastal: /seascape|waterscape|coast|marine|ocean|harbour|harbor|beach/.test(text),
      botanic: /botanic|floral|garden|leaf|wisteria|lily|bloom|foliage/.test(text),
      abstract: /abstract|geometry|geometric/.test(text),
      urban: /architect|urban|city|skyline|new york|london|paris|industrial/.test(text),
      architecture: /architect/.test(text),
      wildlife: /bird|wildlife|animal|deer|fox/.test(text),
      mono: /monochrome|black and white|\bbw\b/.test(text + " " + foldText(product.genre)),
      warm: /warm|glow|earth|ochre|amber|terracotta/.test(text),
      calm: /calm|quiet|soft|still|gentle/.test(text),
      vibrant: /vibrant|bold|punch|vivid|saturated/.test(text),
      dusk: /twilight|dusk|sunset|night|evening|noir/.test(text),
      cool: /cool|blue|slate|silver|violet|purple|indigo/.test(text + " " + colours),
      green: /green|sage|olive|moss/.test(text + " " + colours),
      earthy: /brown|sand|linen|clay|stone|cream/.test(text + " " + colours),
      wide: Math.max(frame.w, frame.h) >= 90
    };
  }

  function rooms() {
    return [
      {
        id: "lounge",
        name: "sitting room",
        hang: {
          pano: "Hang it on the long wall above a sofa, with breathing room either side — this width needs a proper run of wall, not a chimney breast.",
          landscape: "Hang it centred above a sofa or sideboard, at comfortable viewing height.",
          square: "Hang it at eye height on a chimney breast, between windows, or over a low console.",
          portrait: "Hang it on a quieter wall beside the seating, not crammed over a low sofa back."
        },
        setting: "A lived-in British sitting room: plaster or limewash walls, a linen or wool sofa that is actually sat in, timber or a quiet rug. Not a hotel lobby.",
        boost: ["default", "calm", "warm", "abstract", "coastal", "wildlife"],
        avoid: []
      },
      {
        id: "kitchen",
        name: "kitchen-diner",
        hang: {
          pano: "Hang it on the longest free wall, away from splashbacks and wall cabinets — a panoramic needs horizontal wall, not a cooker hood.",
          landscape: "Hang it on a clear run of wall above a sideboard or between cabinetry, well clear of taps and shelves.",
          square: "Hang it on a chimney breast or a cabinet-free stretch, at standing eye height.",
          portrait: "Hang it on a narrow free wall or the end of a run of cabinets, not over a hob."
        },
        setting: "A real kitchen-diner: painted cabinetry, timber or stone worktop, a lived-in table, one or two ceramics. No showroom island.",
        boost: ["botanic", "earthy", "warm", "calm"],
        avoid: ["dusk", "urban", "mono", "pano"]
      },
      {
        id: "office",
        name: "study",
        hang: {
          pano: "Hang it on the wall behind or beside the desk, on a long plaster run, not above a low monitor shelf.",
          landscape: "Hang it behind the desk or on the facing wall, centred at seated-to-standing eye height.",
          square: "Hang it beside a bookcase or on the wall opposite the desk, at eye height.",
          portrait: "Hang it in the alcove beside the desk or between bookcases, with space to read it up close."
        },
        setting: "A home study or office: dark timber or painted shelves, a simple desk, paper and books that look used.",
        boost: ["urban", "abstract", "mono", "architecture"],
        avoid: ["botanic"]
      },
      {
        id: "bedroom",
        name: "bedroom",
        hang: {
          pano: "Hang it on the wall opposite the bed or on a long side wall — not as a cramped headboard picture.",
          landscape: "Hang it above the headboard only if the wall is wide enough; otherwise on the facing wall.",
          square: "Hang it above a chest of drawers, or centred on the wall opposite the bed.",
          portrait: "Hang it beside a window or over a chest of drawers, at standing eye height."
        },
        setting: "A quiet bedroom: rumpled linen, a timber or painted chest, a reading lamp. Calm, private, not a staged hotel suite.",
        boost: ["calm", "coastal", "botanic"],
        avoid: ["vibrant"]
      },
      {
        id: "conservatory",
        name: "conservatory",
        hang: {
          pano: "Hang it on the solid back wall, not on glass — a panoramic needs masonry, with garden light from the side.",
          landscape: "Hang it on the solid house wall of the conservatory, with plants kept out of the frame’s rectangle.",
          square: "Hang it on the brick or plaster return, not on a mullion.",
          portrait: "Hang it on a solid pier between windows, with space around the moulding."
        },
        setting: "A British conservatory or garden room: painted timber, terracotta pots, garden light, a worn armchair. Plants around the print, never in front of it.",
        boost: ["botanic", "coastal", "green", "calm"],
        avoid: ["dusk", "urban", "mono"]
      },
      {
        id: "hallway",
        name: "hallway",
        hang: {
          pano: "Only use a hallway if it is a long, generous corridor wall. Do not force a panoramic onto a narrow landing.",
          landscape: "Hang it along the corridor wall at standing height, with a clear sightline as you enter.",
          square: "Hang it opposite the front door or on a stair half-landing, centred on the plaster.",
          portrait: "Hang it beside a doorway or on the stair wall, with room to view it from a step back."
        },
        setting: "A hallway or landing: runner or bare boards, a console or nothing at all, coats kept out of shot. Architecture leads; the print is the pause.",
        boost: ["portrait", "urban", "mono", "architecture"],
        avoid: ["pano"]
      },
      {
        id: "dining",
        name: "dining room",
        hang: {
          pano: "Hang it on the long wall above a sideboard, parallel to the table, with space either side.",
          landscape: "Hang it centred on the wall the diners face, above a sideboard, not above the table itself.",
          square: "Hang it on the end wall or chimney breast, aligned with the table axis.",
          portrait: "Hang it on a side wall or in an alcove, not competing with a low pendant over the table."
        },
        setting: "A dining room that is used: timber table, simple chairs, a sideboard, one candle or a bowl — not a wedding-catalogue setting.",
        boost: ["landscape", "pano", "botanic", "warm"],
        avoid: []
      }
    ];
  }

  function scoreRoom(room, sig) {
    var score = 1.2;
    var i;
    if (room.boost) {
      for (i = 0; i < room.boost.length; i += 1) {
        if (room.boost[i] === "default") score += 0.4;
        else if (room.boost[i] === sig.ori) score += 2.4;
        else if (sig[room.boost[i]]) score += 2.2;
      }
    }
    if (room.avoid) {
      for (i = 0; i < room.avoid.length; i += 1) {
        if (room.avoid[i] === sig.ori || sig[room.avoid[i]]) score -= 3;
      }
    }
    if (sig.wide && (room.id === "hallway" || room.id === "kitchen")) score -= 2.2;
    return score;
  }

  function interiorTone(sig, colours) {
    var list = (colours || []).map(function (c) { return String(c || "").toLowerCase(); });
    var named = prettyList(list);
    if (sig.dusk || /violet|purple|indigo/.test(sig.text)) {
      return "Keep the room in oatmeal, greige, warm plaster, or dusty taupe. Do not paint walls purple or violet to match the print. Evening lamps are fine; the artwork should still be the strongest colour in the room.";
    }
    if (sig.mono) {
      return "Off-white or pale grey plaster, dark timber, charcoal or oatmeal textiles. Almost no chroma so the print’s blacks and whites stay clean.";
    }
    if (sig.green || sig.botanic) {
      return "Sage, garden plaster, terracotta pots, and natural linen. Greens in the room should be duller than anything in the print.";
    }
    if (sig.coastal) {
      return "Pale plaster, stone, linen. Sea light, no anchors, no stripe clichés, no matching the print’s blues on the walls.";
    }
    if (sig.cool) {
      return "Cool plaster, slate-grey or stone underfoot, linen. Echo " + (named || "the print’s cooler notes") + " only in a book spine or a throw, never as a matching feature wall.";
    }
    if (sig.warm || sig.earthy) {
      return "Clay plaster, wool, ceramic, and warm linen. Let textiles quietly nod to " + (named || "the earth tones") + " without looking like a mood board.";
    }
    if (named) {
      return "Let one quiet textile or ceramic echo " + named + ". The walls must stay quieter than the print so the artwork leads.";
    }
    return "Keep the room palette quieter than the print so the artwork leads.";
  }

  function sceneLight(sig) {
    if (sig.dusk) {
      return pickOne([
        "Dusk inside: one warm lamp and the last of the daylight on the wall. Believable, not a cinematic grade or neon.",
        "Early evening, lamps on, still a trace of sky in a window. No HDR, no orange Instagram filter."
      ]);
    }
    if (sig.warm) {
      return pickOne([
        "Late-afternoon warm daylight raking across the wall — natural, not a sunset cliché.",
        "Soft side-light from a window, slightly golden, with gentle falloff."
      ]);
    }
    if (sig.calm || sig.coastal) {
      return pickOne([
        "Quiet north light, even and pale, as if the room faces a garden.",
        "Overcast British daylight. Soft, no hard shadows, no HDR."
      ]);
    }
    return pickOne([
      "Soft daylight from one side. Gentle falloff. No HDR, no neon, no cinematic colour grade.",
      "Morning side-light, still and ordinary, like a real house at 10am.",
      "Overcast daylight through a window out of frame. Honest, not glossy."
    ]);
  }

  function sceneChaos(sig, room) {
    var pool = [
      "Lived-in, not catalogued: one cup or a book on a surface, nothing styled in a grid.",
      "A trailing houseplant is allowed at the edge of the frame, never covering the print.",
      "Textiles slightly used — a throw not perfectly folded.",
      "A stack of two or three books, spines not facing the camera as product shots.",
      "Leave a little honest mess at the edge: a cushion dented, a chair not squared to the wall."
    ];
    if (room.id === "kitchen") pool.push("A chopping board or a bowl of fruit is fine; no giant branded bottles.");
    if (room.id === "bedroom") pool.push("The bed is made but not hotel-tight.");
    if (room.id === "office") pool.push("A notebook or a lamp on the desk; no glowing monitors competing with the print.");
    if (sig.botanic) pool.push("Cut greenery in a simple vase, not a florist explosion.");
    return pickOne(pool);
  }

  function plan(product, roomId) {
    var sig = sceneSignals(product);
    var ranked = rooms().map(function (room) {
      return {
        room: room,
        score: scoreRoom(room, sig)
      };
    }).filter(function (item) {
      return item.score > 0.4;
    }).sort(function (a, b) {
      return b.score - a.score;
    });
    if (!ranked.length) ranked = [{ room: rooms()[0], score: 1 }];
    var shortlist = ranked.filter(function (item) {
      return item.score >= ranked[0].score - 2.2;
    }).slice(0, 4);
    var wanted = String(roomId || "auto").toLowerCase();
    var chosen = wanted && wanted !== "auto"
      ? rooms().filter(function (room) { return room.id === wanted; })[0]
      : null;
    if (!chosen) chosen = pickOne(shortlist).room;
    var hang = chosen.hang[sig.ori] || chosen.hang.landscape;
    var colours = colourLabels(product);
    var tone = interiorTone(sig, colours);
    var light = sceneLight(sig);
    var chaos = sceneChaos(sig, chosen);
    var scale = frameScaleCopy(product);
    var lens = pickOne([
      "Shot at eye level on a 50mm lens, shallow but believable depth of field, editorial UK interiors, 2020s. Stand close enough that the " + scale.cm + " frame is the hero; do not step back into an ultrawide establishing shot.",
      "Shot at standing eye height, 35–50mm, natural perspective, editorial UK interiors, 2020s. No ultrawide distortion. Fill the photograph so the " + scale.cm + " print is large in the frame.",
      "A quiet 50mm photograph, eye level, the " + scale.cm + " print sharp enough to read and large in the photograph, the room falling away softly."
    ]);
    var notes = [
      "**This export:** " + chosen.name + " · " + sig.ori + " hang · " + scale.cm + " single frame. Re-export for a different, still-appropriate room.",
      hang,
      chosen.setting,
      scale.line,
      tone,
      light,
      chaos,
      "The architecture must actually fit this " + scale.cm + " " + sig.ori + " frame. Do not put a wide panoramic on a narrow chimney breast, or a tall portrait over a low kitchen splashback. Keep the artwork identical to the attached reference."
    ].join("\n\n");
    var promptLine = [
      "Photorealistic interior photograph of the attached framed print hanging in a real British " + chosen.name + ".",
      hang,
      chosen.setting,
      scale.line,
      tone,
      light,
      chaos,
      lens
    ].join(" ");
    return {
      room: chosen.name,
      roomId: chosen.id,
      notes: notes,
      promptLine: promptLine
    };
  }

  function prompt(product, roomId, variation) {
    var scene = plan(product, roomId);
    var frame = frameSizeFor(product);
    var frameCm = frame.w + "×" + frame.h + "cm";
    var extra = [
      "The framed print is already hanging in the photograph at " + frameCm + ".",
      product && product.lockImage
        ? "Use the attached 2nd image exactly as it is. Paint the room around it. Do not add or remove a mount. Do not change the frame colour, the moulding face, or the print. A side edge of the same moulding is allowed; the front must stay identical."
        : "",
      "Do not crop the print into a different format.",
      "Do not redraw, crop, move, resize, or replace the print.",
      "The print is the hero — large enough to read, naturally part of the room.",
      "No overlay text, no watermark, no logo, no extra frames of different art, no plastic 3D mockup look.",
      "Photoreal photograph, not illustration. British home, 2020s.",
      variation > 1
        ? "This is variation " + variation + " — keep the same print and room type, change the furniture arrangement and the light."
        : ""
    ].filter(Boolean).join(" ");
    return {
      scene: scene,
      prompt: (scene.promptLine + " " + extra).slice(0, 4000)
    };
  }

  function captionPlan(roomId) {
    var plans = {
      lounge: {
        hang: {
          pano: "hanging along the long sitting-room wall above the sofa",
          landscape: "hanging above the sofa in a sitting room",
          square: "hanging on the sitting-room chimney breast",
          portrait: "hanging on a quieter sitting-room wall beside the seating"
        },
        feel: "It looks at home against plaster and linen — a piece you live with, not a showroom prop."
      },
      kitchen: {
        hang: {
          pano: "hanging on the longest free wall of the kitchen-diner",
          landscape: "hanging on a clear kitchen-diner wall, between the cabinets",
          square: "hanging on a cabinet-free stretch of the kitchen-diner",
          portrait: "hanging on a narrow kitchen-diner wall at the end of the run"
        },
        feel: "Painted cabinets, a table in daily use. The print is the still point above breakfast, well clear of taps and clutter."
      },
      office: {
        hang: {
          pano: "hanging on the long wall behind or beside the desk",
          landscape: "hanging behind the desk in a home study",
          square: "hanging beside the bookcase in a home study",
          portrait: "hanging in the alcove beside the desk"
        },
        feel: "Shelves, paper, books that look read. It gives the study a proper pause — present, not corporate."
      },
      bedroom: {
        hang: {
          pano: "hanging on the long wall opposite the bed",
          landscape: "hanging above the headboard in a bedroom",
          square: "hanging above a chest of drawers in a bedroom",
          portrait: "hanging beside the window in a bedroom"
        },
        feel: "Rumpled linen and low light. The print keeps the bedroom quiet rather than busy."
      },
      conservatory: {
        hang: {
          pano: "hanging on the solid back wall of a conservatory",
          landscape: "hanging on the house wall of a conservatory",
          square: "hanging on the plaster return of a conservatory",
          portrait: "hanging on a solid pier between the garden windows"
        },
        feel: "Garden light from the side, terracotta at its feet. The print sits on masonry, with the plants kept around it, never over it."
      },
      hallway: {
        hang: {
          pano: "hanging on a long corridor wall",
          landscape: "hanging along the hallway wall at standing height",
          square: "hanging opposite the door, or on the stair landing",
          portrait: "hanging on the stair wall, or beside a doorway"
        },
        feel: "Boards, a runner, the architecture leading you through. You catch the print on the way in — a pause on the landing, not a gallery label."
      },
      dining: {
        hang: {
          pano: "hanging on the long dining-room wall above a sideboard",
          landscape: "hanging on the wall the diners face, above a sideboard",
          square: "hanging on the end wall of a dining room",
          portrait: "hanging in a dining-room alcove, clear of the pendant"
        },
        feel: "A table that is used, a sideboard, one bowl or a candle. The print earns the wall at dinner, not a catalogue set."
      }
    };
    return plans[roomId] || plans.lounge;
  }

  function roomByKey(key) {
    var fold = foldText(key);
    var list = rooms();
    var i;
    if (!fold || fold === "auto") return null;
    for (i = 0; i < list.length; i += 1) {
      if (list[i].id === fold || foldText(list[i].name) === fold) return list[i];
    }
    return null;
  }

  function frameLabel(options) {
    var opts = options || {};
    var style = String(opts.frameStyle || opts.style || "").replace(/\s+/g, " ").trim();
    var colour = String(opts.colour || opts.color || "").replace(/\s+/g, " ").trim();
    return [style, colour].filter(Boolean).join(" ");
  }

  function caption(product, roomKey, options) {
    var chosen = roomByKey(roomKey);
    if (!chosen) {
      var scene = plan(product, roomKey);
      chosen = roomByKey(scene.roomId) || rooms()[0];
    }
    var bits = captionPlan(chosen.id);
    var ori = oriKind(product);
    var where = (bits.hang && (bits.hang[ori] || bits.hang.landscape)) || "hanging in a British interior";
    var title = String((product && product.title) || "Framed print").replace(/\s+/g, " ").trim();
    var vendor = String((product && product.vendor) || "").replace(/\s+/g, " ").trim();
    var byline = vendor ? title + " by " + vendor : title;
    var frame = frameLabel(options || (product && product.frameOptions) || {});
    var lead = frame ? byline + ", in " + frame + ", " + where + "." : byline + ", " + where + ".";
    return (lead + " " + bits.feel).replace(/\s+/g, " ").trim().replace(/[.]{2,}/g, ".").slice(0, 400);
  }

  function titleCase(name) {
    return String(name || "").replace(/\b[a-z]/g, function (ch) {
      return ch.toUpperCase();
    });
  }

  function roomName(product, roomId) {
    var id = String(roomId || "auto").toLowerCase();
    if (id && id !== "auto") {
      var named = rooms().filter(function (room) { return room.id === id; })[0];
      if (named) return named.name;
    }
    return plan(product, id).room;
  }

  function fillSelect(selectEl) {
    if (!selectEl) return;
    var current = selectEl.value || "auto";
    selectEl.innerHTML = "";
    var auto = document.createElement("option");
    auto.value = "auto";
    auto.textContent = "Auto — match the print";
    selectEl.appendChild(auto);
    rooms().forEach(function (room) {
      var opt = document.createElement("option");
      opt.value = room.id;
      opt.textContent = titleCase(room.name);
      selectEl.appendChild(opt);
    });
    selectEl.value = selectEl.querySelector('option[value="' + current + '"]') ? current : "auto";
  }

  function bannerPrompt(product, roomId, collectionTitle, variation) {
    var scene = plan(product, roomId);
    var frame = frameSizeFor(product);
    var frameCm = frame.w + "×" + frame.h + "cm";
    var collection = String(collectionTitle || "").replace(/\s+/g, " ").trim();
    var voice = collection
      ? "The room should feel right for a collection titled “" + collection + "” — use that only as interior voice, never letter it onto the photograph."
      : "";
    var extra = [
      "Compose this as a cinematic wall-length photograph for a website banner, not a square product shot.",
      "Camera at standing eye height, 35mm, almost no ceiling and almost no floor — a wide run of plaster with the hanging print as the only artwork.",
      product && product.lockImage
        ? "The product's 2nd image is already in the photograph, on the right, at one " + frameCm + ". Paint the room around it. Do not add or remove a mount. Do not change the frame colour, the moulding face, or the print. A side edge of the same moulding is allowed; the front must stay identical."
        : "Place the framed print in the right third of the photograph, large enough to read, true domestic scale of one " + frameCm + " single frame.",
      "Keep the left half quiet negative space: empty plaster or a soft fall of light, no furniture blocking that side, no extra frames, no plants covering the left wall.",
      "That left half is reserved for website type that will sit over the photograph. Do not paint words, watermarks, logos, or captions onto the image.",
      "Keep the artwork, frame moulding, mount, and proportions identical to the attached reference. Do not redraw, crop, invent a different print, or split it into a diptych or triptych.",
      voice,
      "Photoreal British home, 2020s. No plastic 3D mockup look.",
      variation > 1
        ? "This is variation " + variation + " — keep the same print and room type, change the time of day and the quiet objects on the right, never crowd the left wall."
        : ""
    ].filter(Boolean).join(" ");
    return {
      scene: scene,
      prompt: (scene.promptLine + " " + extra).slice(0, 4000)
    };
  }

  function sizedLockedUrl(url, width) {
    if (!url || url.indexOf("data:") === 0) return url;
    if (/([?&])width=\d+/i.test(url)) return url.replace(/([?&])width=\d+/i, "$1width=" + width);
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "width=" + width;
  }

  function loadLockedImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error("image_fetch_failed")); };
      img.src = url;
    });
  }

  function lockedPhotoBounds(img) {
    var canvas = document.createElement("canvas");
    var w = img.naturalWidth || img.width;
    var h = img.naturalHeight || img.height;
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var full = { canvas: canvas, x: 0, y: 0, w: w, h: h };
    var data;
    try { data = ctx.getImageData(0, 0, w, h).data; } catch (error) { return full; }
    var minX = w;
    var minY = h;
    var maxX = 0;
    var maxY = 0;
    var found = false;
    var step = Math.max(1, Math.floor(Math.min(w, h) / 400));
    var y;
    var x;
    for (y = 0; y < h; y += step) {
      for (x = 0; x < w; x += step) {
        var i = (y * w + x) * 4;
        if (data[i + 3] < 16) continue;
        if (data[i] > 246 && data[i + 1] > 246 && data[i + 2] > 246) continue;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        found = true;
      }
    }
    if (!found) return full;
    minX = Math.max(0, minX - step);
    minY = Math.max(0, minY - step);
    maxX = Math.min(w - 1, maxX + step);
    maxY = Math.min(h - 1, maxY + step);
    return { canvas: canvas, x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
  }

  function lockedCanvasSize(aspect, forced) {
    if (forced === "1536x1024") return { w: 1536, h: 1024, name: "1536x1024" };
    if (forced === "1024x1536") return { w: 1024, h: 1536, name: "1024x1536" };
    if (forced === "1024x1024") return { w: 1024, h: 1024, name: "1024x1024" };
    if (aspect > 1.15) return { w: 1536, h: 1024, name: "1536x1024" };
    if (aspect < 0.87) return { w: 1024, h: 1536, name: "1024x1536" };
    return { w: 1024, h: 1024, name: "1024x1024" };
  }

  function canvasToDataUrl(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      if (!canvas || !canvas.toBlob) {
        reject(new Error("invalid_image"));
        return;
      }
      canvas.toBlob(function (blob) {
        if (!blob) {
          reject(new Error("invalid_image"));
          return;
        }
        var reader = new FileReader();
        reader.onload = function () { resolve(String(reader.result || "")); };
        reader.onerror = function () { reject(new Error("invalid_image")); };
        reader.readAsDataURL(blob);
      }, type, quality);
    });
  }

  function prepareLockedScene(imageUrl, options) {
    var src = sizedLockedUrl(String(imageUrl || "").trim(), 1600);
    if (!src) return Promise.reject(new Error("missing_image"));
    var align = options && options.align === "right" ? "right" : "center";
    var forced = options && options.size;
    return loadLockedImage(src).then(function (img) {
      var bounds = lockedPhotoBounds(img);
      var size = lockedCanvasSize(bounds.w / bounds.h, forced);
      var plate = document.createElement("canvas");
      plate.width = size.w;
      plate.height = size.h;
      var ctx = plate.getContext("2d");
      ctx.fillStyle = "#e7e1d6";
      ctx.fillRect(0, 0, size.w, size.h);
      var scale;
      var dw;
      var dh;
      var dx;
      var dy;
      if (align === "right") {
        scale = Math.min((size.w * 0.36) / bounds.w, (size.h * 0.78) / bounds.h);
        dw = bounds.w * scale;
        dh = bounds.h * scale;
        dx = size.w - dw - Math.round(size.w * 0.06);
        dy = (size.h - dh) / 2;
      } else {
        scale = Math.min((size.w * 0.42) / bounds.w, (size.h * 0.5) / bounds.h);
        dw = bounds.w * scale;
        dh = bounds.h * scale;
        dx = (size.w - dw) / 2;
        dy = Math.max(24, size.h * 0.16);
      }
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(bounds.canvas, bounds.x, bounds.y, bounds.w, bounds.h, dx, dy, dw, dh);
      var mask = document.createElement("canvas");
      mask.width = size.w;
      mask.height = size.h;
      var maskCtx = mask.getContext("2d");
      maskCtx.clearRect(0, 0, size.w, size.h);
      maskCtx.fillStyle = "#000000";
      maskCtx.fillRect(Math.round(dx), Math.round(dy), Math.round(dw), Math.round(dh));
      var lock = {
        canvas: bounds.canvas,
        sx: bounds.x,
        sy: bounds.y,
        sw: bounds.w,
        sh: bounds.h,
        dx: dx,
        dy: dy,
        dw: dw,
        dh: dh,
        w: size.w,
        h: size.h
      };
      return Promise.all([
        canvasToDataUrl(plate, "image/jpeg", 0.92),
        canvasToDataUrl(mask, "image/png")
      ]).then(function (parts) {
        if (!parts[0] || !parts[1]) throw new Error("missing_image");
        return { image: parts[0], mask: parts[1], size: size.name, lock: lock };
      });
    });
  }

  function pasteLockedScene(sceneUrl, lock) {
    if (!lock || !sceneUrl) return Promise.resolve("");
    return loadLockedImage(sceneUrl).then(function (sceneImg) {
      var canvas = document.createElement("canvas");
      canvas.width = lock.w;
      canvas.height = lock.h;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(sceneImg, 0, 0, lock.w, lock.h);
      ctx.drawImage(lock.canvas, lock.sx, lock.sy, lock.sw, lock.sh, lock.dx, lock.dy, lock.dw, lock.dh);
      return canvasToDataUrl(canvas, "image/jpeg", 0.92);
    });
  }

  root.ArtfolioScenes = {
    rooms: rooms,
    plan: plan,
    prompt: prompt,
    bannerPrompt: bannerPrompt,
    titleCase: titleCase,
    fillSelect: fillSelect,
    frameSize: frameSizeFor,
    roomName: roomName,
    caption: caption,
    describeFrame: describeFrame,
    resolveFrameFacts: resolveFrameFacts,
    prepareLockedScene: prepareLockedScene,
    pasteLockedScene: pasteLockedScene
  };
})(window);
